var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"contacts-card-link",attrs:{"href":_vm.link,"target":_vm.target}},[_c('FaqAndSupportContactsCard',{attrs:{"label":_vm.label,"text":_vm.text}},[_c('VIconMTS',{attrs:{"name":"faq_and_support/icon-arrow","width":"44","height":"44"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }